import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { autoinject, transient } from "aurelia-framework";

@autoinject
@transient()
export class IntroduceMessageCenter {

    public imgUrl: string = require('../../../../../images/quickstart/01.png');
    public email: string;
    public learnMoreUrl: string;

    constructor(private configService: ConfigService) { }

    activate (model: { email: string }) {
        this.learnMoreUrl = this.configService.config.urls.aboutMessageCenterUrl;
        this.email = model.email;
    }

    onLearnMoreClick() {
        window.open(this.learnMoreUrl);
    }
}
